import { ActionContext, Module } from "vuex";
import { State } from "../store";

export type LoadingState = {
  loadingCount: number;
  overlayLoadingCount: number;
};

const loadingModule: Module<LoadingState, State> = {
  namespaced: true,
  state: {
    loadingCount: 0,
    overlayLoadingCount: 0,
  },
  getters: {
    isLoading(state) {
      return state.loadingCount > 0;
    },
    isOverlayLoading(state) {
      return state.overlayLoadingCount > 0;
    },
  },
  mutations: {
    beginLoading(state) {
      state.loadingCount++;
    },
    endLoading(state) {
      state.loadingCount--;
      if (state.loadingCount < 0) {
        console.warn("Loading count went negative, check your code!");
        state.loadingCount = 0;
      }
    },
    beginOverlayLoading(state) {
      state.overlayLoadingCount++;
    },
    endOverlayLoading(state) {
      state.overlayLoadingCount--;
      if (state.overlayLoadingCount < 0) {
        console.warn("Loading count went negative, check your code!");
        state.overlayLoadingCount = 0;
      }
    },
  },
  actions: {
    async wrapLoading<T>({ commit }: ActionContext<LoadingState, State>, fn: () => Promise<T>) {
      commit("beginLoading", null);

      try {
        return await fn();
      } finally {
        commit("endLoading", null);
      }
    },
    async wrapOverlayLoading<T>({ commit }: ActionContext<LoadingState, State>, fn: () => Promise<T>) {
      commit("beginOverlayLoading", null);

      try {
        return await fn();
      } finally {
        commit("endOverlayLoading", null);
      }
    },
  },
};

export default loadingModule;
